import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
// Import directo al path interno del atom (no al barrel `'ui'`) para evitar
// dependencia circular: `ui/index.ts` exporta `Dialog`, que importa este
// `FooterButtons`, que a su vez importaría desde `'ui'` — el barrel estaría
// a medio inicializar y `Button` saldría `undefined`.
import Button from 'ui/atoms/Button/Button';
const FooterButtons = ({ autoFocusCancel, buttonIconSucess, buttonTextCancel, buttonTextSucess, loading, onSuccess, onCancel, disabledSuccess, className }) => {
  return (
    <div className={clsx('footer-buttons', className)}>
      {onCancel && (
        <Button
          autoFocus={autoFocusCancel}
          variant="secondary-ghost"
          isDisabled={loading}
          onClick={onCancel}
          size="sm"
          text={buttonTextCancel}
          type="reset"
        />
      )}
      {onSuccess && (
        <Button
          isDisabled={disabledSuccess || loading}
          leftIcon={buttonIconSucess}
          isLoading={loading}
          onClick={onSuccess}
          size="sm"
          text={buttonTextSucess}
          type="submit"
        />
      )}
    </div>
  );
};

FooterButtons.propTypes = {
  autoFocusCancel: PropTypes.bool,
  buttonIconSucess: PropTypes.string,
  buttonTextCancel: PropTypes.string,
  buttonTextSucess: PropTypes.string,
  loading: PropTypes.bool,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func,
  disabledSuccess: PropTypes.bool,
  className: PropTypes.string,
};

FooterButtons.defaultProps = {
  buttonTextCancel: 'Cancel',
  buttonTextSucess: 'Confirm',
  loading: false,
  typeButtonSuccess: '',
  disabledSuccess: false,
};

export default FooterButtons;
